import { useState } from 'react';
import { comparePaymentsModalOpened, comparePaymentsModalClosed, comparePaymentsModalSubmitted, comparePaymentsModalAddCalculator, } from '../../core/reducers/ui';
import { useAppSelector, useAppDispatch } from '../../core/utils';
import useScreenSize from '../../utils/hooks/useScreenSize';
const usePaymentCompareModal = () => {
    const dispatch = useAppDispatch();
    const { isExtraLarge } = useScreenSize();
    const compareCalculatorId1 = 'compare1';
    const compareCalculatorId2 = 'compare2';
    const compareCalculatorId3 = 'compare3';
    const [visibleCalculators, setVisibleCalculators] = useState([compareCalculatorId1, compareCalculatorId2]);
    const isModalOpen = useAppSelector(state => { var _a; return (_a = state.ui.ConfigureBap) === null || _a === void 0 ? void 0 : _a.isCompareModalOpen; });
    const allowThirdCalculator = isExtraLarge;
    const openModal = () => {
        dispatch(comparePaymentsModalOpened([compareCalculatorId1, compareCalculatorId2]));
    };
    const closeModal = () => {
        setVisibleCalculators([compareCalculatorId1, compareCalculatorId2]);
        dispatch(comparePaymentsModalClosed([compareCalculatorId1, compareCalculatorId2, compareCalculatorId3]));
    };
    const submitModalForm = (selectedCalculatorId) => {
        setVisibleCalculators([compareCalculatorId1, compareCalculatorId2]);
        if (selectedCalculatorId) {
            dispatch(comparePaymentsModalSubmitted([compareCalculatorId1, compareCalculatorId2, compareCalculatorId3], selectedCalculatorId));
        }
    };
    const addCalculator = (copyFromCalculatorId) => {
        if (copyFromCalculatorId) {
            dispatch(comparePaymentsModalAddCalculator(copyFromCalculatorId, compareCalculatorId3));
            setVisibleCalculators([compareCalculatorId1, compareCalculatorId2, compareCalculatorId3]);
        }
    };
    return {
        compareCalculatorId1,
        compareCalculatorId2,
        compareCalculatorId3,
        isModalOpen,
        openModal,
        closeModal,
        submitModalForm,
        addCalculator,
        allowThirdCalculator,
        visibleCalculators: allowThirdCalculator ? visibleCalculators : visibleCalculators.slice(0, 2),
    };
};
export default usePaymentCompareModal;
